//check if you are on the target page
function pagechecker(page_type,handle) {
  var url_check = current_url.split('/');
  if (page_type == "All") {
    return true
  }
  if (handle != undefined && handle != NaN) {
    if (url_check[3] == page_type && url_check[url_check.length - 1]) {
      return true
    }
  } else {
    if (url_check[3] == page_type && handle == undefined) {
      return true
    }
  }
}
//capitalize first letter of the string
function capitalize (s){
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
//checks number of times the word appeared inside paragraph
function search_word(paragraph, word){
  var x = 0, y=0;
  var split_paragraph = paragraph.split(' ');
  for (let sp = 0; sp < split_paragraph.length; sp++) {
    if (split_paragraph[sp] == word || split_paragraph[sp] == word + ',' || split_paragraph[sp] == word + '.') {
      x++;
      // console.log(split_paragraph[sp])
      // split_paragraph[sp] = "upper_word_replacement_queue";
      // split_paragraph = split_paragraph.join(' ')
      // target_string = split_paragraph;
      // break
    }
  }
  // for (i=0;i< paragraph.length;i++)
  //     {
  //     if(paragraph[i] == word[0])
  //         {
  //         for(j=i;j< i+word.length;j++)
  //            {
  //             if(paragraph[j]==word[j-i])
  //               {
  //                 y++;
  //               }
  //             if (y==word.length){
  //                 x++;
  //             }
  //         }
  //         y=0;
  //     }
  // }
 return x;
}
//accepts target_paragraph as element
function wordTransform(target_paragraph,target_word, replaced_word, times, changed_times,lowerAndUpper) {
  var target_string = target_paragraph.innerHTML;
  for (let w = 0; w < target_word.length ; w++) {
    // console.log(changed_times)
    var times_found = 0
    var times_needed = times[w] - changed_times[w];
    var times_found_lower = 0;
    var times_found_upper = 0;
    var capitalizedWord = capitalize(target_word[w]);
    times_found = search_word(target_paragraph.textContent,target_word[w]);
    if (times_needed >= times_found) {
      // console.log(target_paragraph)
      // console.log("Word: " + target_word[w] + " " + times_needed + " : " + times_found)
      // console.log(changed_times)
      changed_times[w] = changed_times[w] + times_found;
    } else {
      // console.log(target_paragraph)
      // console.log("Word: " + target_word[w] + " " + times_needed + " : " + times_found + "TEST")
      // console.log(changed_times)
      changed_times[w] = times[w]
    }
    // console.log("Word: " + target_word[w] + " " + times_needed + " : " + times_found)
    // console.log(target_paragraph)
    if (lowerAndUpper[w]) {
      times_found_lower = search_word(target_paragraph.textContent,target_word[w]);
      times_found_upper = search_word(target_paragraph.textContent,capitalizedWord)
      times_found = times_found_lower + times_found_upper;
      // console.log("Word: " + target_word[w] + " Capitalized: " + capitalizedWord + " Times found Upper: " + times_found_upper + " Times found Lower: " + times_found_lower + " Times needed: " + times_needed)
      // console.log(target_string)
      if (times_needed > times_found_upper) {
        for (let c = 0; c < times_needed; c++) {
          var split_paragraph = target_string.split(' ');
          for (let sp = 0; sp < split_paragraph.length; sp++) {
            if (split_paragraph[sp] == capitalizedWord || split_paragraph[sp] == capitalizedWord + ',' || split_paragraph[sp] == capitalizedWord + '.') {
              // console.log(split_paragraph[sp])
              if (split_paragraph[sp] == target_word[w] + ",") {
                split_paragraph[sp] = "upper_word_replacement_with_,_queue";
              } else if (split_paragraph[sp] == target_word[w] + ".") {
                split_paragraph[sp] = "upper_word_replacement_with_._queue";
              } else {
                split_paragraph[sp] = "upper_word_replacement_queue";
              }
              // split_paragraph[sp] = "upper_word_replacement_queue";
              split_paragraph = split_paragraph.join(' ')
              target_string = split_paragraph;
              break
            }
          }
          // target_string = target_string.replace(capitalizedWord, "upper_word_replacement_queue");
        }
        times_needed = times_needed - times_found_upper;
        for (let c = 0; c < times_needed; c++) {
          // console.log(c + " : " + times_needed)
          var split_paragraph = target_string.split(' ');
          for (let sp = 0; sp < split_paragraph.length; sp++) {
            if (split_paragraph[sp] == target_word[w] || split_paragraph[sp] == target_word[w] + "," || split_paragraph[sp] == target_word[w] + "." ) {
              // console.log(split_paragraph[sp])
              if (split_paragraph[sp] == target_word[w] + ",") {
                split_paragraph[sp] = "lower_word_replacement_with_,_queue";
              } else if (split_paragraph[sp] == target_word[w] + ".") {
                split_paragraph[sp] = "lower_word_replacement_with_._queue";
              } else {
                split_paragraph[sp] = "lower_word_replacement_queue";
              }
              // split_paragraph[sp] = "lower_word_replacement_queue";
              // console.log(split_paragraph)
              split_paragraph = split_paragraph.join(' ')
              target_string = split_paragraph;
              // console.log(target_string)
              break
            }
          }
          // target_string = target_string.replace(target_word[w], "lower_word_replacement_queue");
        }
        target_string = target_string.replaceAll("upper_word_replacement_queue", replaced_word[w][0]);
        target_string = target_string.replaceAll("lower_word_replacement_queue", replaced_word[w][1]);
        target_string = target_string.replaceAll("upper_word_replacement_with_,_queue", replaced_word[w][0] + ',');
        target_string = target_string.replaceAll("lower_word_replacement_with_,_queue", replaced_word[w][1] + '.');
        target_string = target_string.replaceAll("upper_word_replacement_with_._queue", replaced_word[w][0] + ',');
        target_string = target_string.replaceAll("lower_word_replacement_with_._queue", replaced_word[w][1] + '.');
      } else {
        for (let c = 0; c < times_needed; c++) {
          var split_paragraph = target_string.split(' ');
          for (let sp = 0; sp < split_paragraph.length; sp++) {
            if (split_paragraph[sp] == capitalizedWord || split_paragraph[sp] == capitalizedWord + "," || split_paragraph[sp] == capitalizedWord + "." ) {
              // console.log(split_paragraph[sp])
              if (split_paragraph[sp] == target_word[w] + ",") {
                split_paragraph[sp] = "upper_word_replacement_with_,_queue";
              } else if (split_paragraph[sp] == target_word[w] + ".") {
                split_paragraph[sp] = "upper_word_replacement_with_._queue";
              } else {
                split_paragraph[sp] = "upper_word_replacement_queue";
              }
              // console.log(split_paragraph)
              split_paragraph = split_paragraph.join(' ')
              target_string = split_paragraph;
              // console.log(target_string)
              break
            }
          }
          // target_string = target_string.replace(capitalizedWord, "upper_word_replacement_queue");
        }
        target_string = target_string.replaceAll("upper_word_replacement_queue", replaced_word[w][0]);
        target_string = target_string.replaceAll("upper_word_replacement_with_,_queue", replaced_word[w][0]);
        target_string = target_string.replaceAll("upper_word_replacement_with_._queue", replaced_word[w][0]);
      }
    } else {
      // console.log("Times Found: " + times_found + " Times Needed: " + times_needed + " Times Limit: " + times[w]);
      for (let c = 0; c < times_needed; c++) {
        // console.log("replacing " + target_word[w] + " with " + replaced_word[w])
        target_string = target_string.replace(target_word[w], "word_replacement_queue");
      }
      target_string = target_string.replaceAll("word_replacement_queue", replaced_word[w]);
    }
  }
  target_paragraph.innerHTML = target_string;
  return changed_times
}
//initialize pagechecker to run wordTransform
var current_url = window.location.href;
var required_pages = [["blogs","spermidine-and-the-fatty-liver"]]
for (let i = 0; i < required_pages.length; i++) {
  // var page_target = pagechecker(required_pages[i][0],required_pages[i][1])
  var page_target = pagechecker(required_pages[i][0])
  // var page_target = pagechecker("All")
  if (page_target) {
    if (required_pages[i][0] == "blogs" && required_pages[i][1] == "spermidine-and-the-fatty-liver") {
      // console.log("checking")
      var target_words = ['spermidine','autophagy'];
      //[word1,word2] if lowerAndUpper is true [[word1_upper,word1_lower], word2]
      var replace_words = [['<strong><a href="https://spermidinelife.us/pages/what-is-spermidine">Spermidine</a></strong>','<strong><a href="https://spermidinelife.us/pages/what-is-spermidine">spermidine</a></strong>'],
      ['<strong><a href="https://spermidinelife.us/pages/what-is-autophagy">Autophagy</a></strong>','<strong><a href="https://spermidinelife.us/pages/what-is-autophagy">autophagy</a></strong>']];
      // var target_paragraphs = $('.article__body.rte').find('p');
      var target_paragraphs = document.body.querySelectorAll(".plug-article__body p");
      // var target_paragraphs = $('body').find('p');
      var times_to_change = [3,3];
      var changed_times = [0,0];
      var lowerAndUpper = [true,true]; // if true lowercase the first letter on target words
      for (let p = 0; p < target_paragraphs.length; p++) {
        //enter "All" for times if all instace of the world is going to be changed
        changed_times = wordTransform(target_paragraphs[p], target_words, replace_words, times_to_change, changed_times, lowerAndUpper);
      }
    }
  }
}
